import PropTypes from 'prop-types';
import React from 'react';
import { generatePath, Link } from 'react-router-dom';

import { activityRoute } from 'App/common/routeLookup';
import { stripAllHtml } from 'App/utils';

const propTypes = {
    note: PropTypes.shape({
        subject: PropTypes.string,
        activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        patientId: PropTypes.string,
    }).isRequired,
    patientId: PropTypes.string.isRequired,
};

const defaultProps = {};

function SummaryNoteSubject({ note, patientId }) {
    const subject = stripAllHtml(note.subject);

    if (!note.activityId) {
        return subject;
    }

    return (
        <Link
            to={{
                pathname: generatePath(activityRoute, {
                    patientId: note.patientId || patientId,
                    activityId: note.activityId,
                }),
            }}
            target="_blank"
            rel="noopener noreferrer"
        >
            {subject}
        </Link>
    );
}

SummaryNoteSubject.propTypes = propTypes;
SummaryNoteSubject.defaultProps = defaultProps;

export default SummaryNoteSubject;
